import { Builder as DeviceBuilder } from '@core/devices/Device'
import { INSTANCE as DeviceManager } from './DeviceManager'
import type { DeviceInfoList } from '@/netadapters/CloudAdapter'
import { DeviceInfoConverter } from '@/netadapters/CloudAdapter'
import { getBackendPushUrl, getApiBaseOrigin } from '@/BuildConfig'
import type { ErrorEvent, CloseEvent } from 'reconnecting-websocket'
import { dataSyncer } from '@core/UCloudDataWebSDK/cloud-data/syncer/DataSyncer'

const MSG_TYPE_DEVICE_INFO = 'DEVICE_CHANNEL_NOTIFY'
const RETRY_LIMIT_TIMES = 10

export interface StateChangeListener {
  onOpen(): void

  onClose(event: CloseEvent): void

  onError(event: ErrorEvent): void
}

export interface OnDeviceChangeListener {
  onDataAdded(packageName: string, data: [object]): void
}

export default class InfoPushClient {
  constructor() {
    if (window.WebSocket) {
      this.#createConnection()
    } else {
      console.error('Current browser DOSE NOT support websocket')
    }
  }

  #deviceListener: OnDeviceChangeListener = {
    onDataAdded: (packageName, value) => {
      console.log(`[DataSyncManager] ${new Date().toLocaleString()} `, '收到了设备消息事件onDataAdded数据为:', value)
      this.#handleMessage(value)
    },
  }

  #createConnection() {
    console.log('InfoPush create connection')

    try {
      dataSyncer.addDeviceChangeListener(MSG_TYPE_DEVICE_INFO, this.#deviceListener)
      const wsAddress: string = getBackendPushUrl()
      const apiAddress: string = getApiBaseOrigin()

      dataSyncer.init({
        wsAddress,
        apiAddress,
        retries: RETRY_LIMIT_TIMES, //重试次数
      })
    } catch (error) {
      console.log(`[DataSyncManager] ${new Date().toLocaleString()} `, 'dataSyncer init failed', error)
    }
  }

  #handleMessage(data: [object]) {
    const deviceInfos = {
      deviceInfos: data,
    }

    try {
      this.#handleDeviceInfo(deviceInfos as DeviceInfoList)
    } catch (e) {
      console.error(`got exception when handle OWork push message: ${e}`)
    }
  }

  #handleDeviceInfo(data: DeviceInfoList) {
    const deviceInfos = data.deviceInfos.map(DeviceInfoConverter)
    const deviceArr = []

    for (const deviceInfo of deviceInfos) {
      const device = DeviceBuilder.build(deviceInfo)

      deviceArr.push(device)
    }

    DeviceManager.updateDeviceList(deviceArr)
  }
}
